var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGlobeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.9987 36.6666C29.2034 36.6666 36.6654 29.2047 36.6654 20C36.6654 10.7952 29.2034 3.33331 19.9987 3.33331C10.794 3.33331 3.33203 10.7952 3.33203 20C3.33203 29.2047 10.794 36.6666 19.9987 36.6666Z",
    stroke: "#7F82A2",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.33203 20H36.6654",
    stroke: "#7F82A2",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9987 3.33331C24.1675 7.89723 26.5366 13.82 26.6654 20C26.5366 26.1799 24.1675 32.1027 19.9987 36.6666C15.8299 32.1027 13.4608 26.1799 13.332 20C13.4608 13.82 15.8299 7.89723 19.9987 3.33331V3.33331Z",
    stroke: "#7F82A2",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGlobeIcon);
export default __webpack_public_path__ + "static/media/globeIcon.b85181973b4bb81cf86278e5ed2262ee.svg";
export { ForwardRef as ReactComponent };